export default __webpack_public_path__ + "static/media/uploader.f2dd0973.svg";